import { Box, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { BodyPartCard } from './BodyPartCard'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import RightArrowIcon from '../../assets/icons/right-arrow.png';
import LeftArrowIcon from '../../assets/icons/left-arrow.png';
import { ExercisesCard } from './ExercisesCard';

const LeftArrow = () => {
    const { scrollPrev } = useContext(VisibilityContext);

    return (
        <Typography onClick={() => scrollPrev()} className="right-arrow">
            <img src={LeftArrowIcon} alt="right-arrow" />
        </Typography>
    );
};

const RightArrow = () => {
    const { scrollNext } = useContext(VisibilityContext);

    return (
        <Typography onClick={() => scrollNext()} className="left-arrow">
            <img src={RightArrowIcon} alt="right-arrow" />
        </Typography>
    );
};

export const HorizontalScrollbar = ({ data, bodyParts, bodyPart, setBodyPart }) => {

    return (

        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
            {
                data.map((item) => (
                    <Box
                        itemId={item.id || item}
                        title={item.id || item}
                        key={item.id || item}
                        m='0 40px'
                    >
                        {
                            bodyParts ? <BodyPartCard
                                item={item}
                                img={item.img}
                                bodyPart={bodyPart}
                                setBodyPart={setBodyPart} /> : <ExercisesCard exercise={item} />
                        }

                    </Box>
                ))
            }
        </ScrollMenu>

    )
}
